import {
  CREATE_WEBSITE_QUERY_QUEUE,
  FETCH_WEBSITE_QUERY_QUEUE_LIST,
  UPDATE_WEBSITE_QUERY_QUEUE,
  ASSIGN_TO_WEBSITE_QUERY_QUEUE,
} from "./types";

export const fetchWebsiteQueryQueues = () => {
  return {
    type: FETCH_WEBSITE_QUERY_QUEUE_LIST,
  };
};

export const createWebsiteQueryQueue = (payload: any) => {
  return {
    type: CREATE_WEBSITE_QUERY_QUEUE,
    payload,
  };
};

export const updateWebsiteQueryQueue = (payload: any) => {
  return {
    type: UPDATE_WEBSITE_QUERY_QUEUE,
    payload,
  };
};

export const assignToWebsiteQueryQueue = (payload: any) => {
  return {
    type: ASSIGN_TO_WEBSITE_QUERY_QUEUE,
    payload,
  };
};
